import { render, staticRenderFns } from "./TrameUploader.vue?vue&type=template&id=89225722&"
import script from "./TrameUploader.vue?vue&type=script&lang=js&"
export * from "./TrameUploader.vue?vue&type=script&lang=js&"
import style0 from "./TrameUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports